export default "__VITE_ASSET__87ec9daf__"